// Fix for accessibility issues. Issue # VII26-08
import { Link } from "react-router-dom";
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  CreditCard,
  DeleteIcon,
  DownloadIcon,
  EllipsisVertical,
  File,
  Home,
  LineChart,
  ListFilter,
  MoreVertical,
  Package,
  Package2,
  PanelLeft,
  Search,
  Settings,
  ShoppingCart,
  Truck,
  Users2,
} from "lucide-react";

import { Badge } from "../../component/ui/badge";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb";
import { Button } from "../../component/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { Input } from "../../component/ui/input";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from "../../component/ui/Pagination";
import { Progress } from "../../component/ui/progress";
import { Separator } from "../../component/ui/separator";
import { Sheet, SheetContent, SheetTrigger } from "../../component/ui/sheet";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../component/ui/tooltip";
import Overview from "../../component/investor/Overview";
import FundManagers from "../../component/investor/FundManagers";
import Performance from "../../component/investor/Performance";
import Portfolio from "../../component/investor/Portfolio";
import SchemeDocuments from "../../component/investor/SchemeDocuments";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { getSchemeInfoAgainstInvestor } from "../../utils/util";
import { useEffect, useState } from "react";
import AdvancedDropdown from "../../component/ui/multi-selection-dropdown-menu-with-search";
import { setAllSchemeDetails } from "../../context/actions/allSchemeDetailsAction";
import DownloadButton from "../../component/investor/DownloadButton";

import { setSchemeInfoDetailsAgainstInvestor } from "../../context/actions/schemeInfoAgainstInvestorAction";
import { setAUMDataAgainstScheme } from "../../context/actions/aumDataAgainstSchemeAction";


export const description =
  "An orders dashboard with a sidebar navigation. The sidebar has icon navigation. The content area has a breadcrumb and search in the header. The main area has a list of recent orders with a filter and export button. The main area also has a detailed view of a single order with order details, shipping information, billing information, customer information, and payment information.";

export function Dashboard({ handleSetTickerMessage = () => {},}) {
  const dispatch = useDispatch();
  const investorInfo = useSelector((state) => state.investorInfo);
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
  const [schemeAndClassOption, setSchemeAndClassOption] = useState([]);
   const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  const [investorSchemeReport, setInvestorSchemeReport] = useState([]);


  // const [schemeFundPerformanceDataForPDF,setSchemeFundPerformanceDataForPDF]=useState()
 const [investorDetailsForPDF,setInvestorDetailsForPDF]=useState({})
 const [aumData,setAumData]=useState([])
  useEffect(() => {
    if (investorInfo && Array.isArray(investorInfo.schemes)) {
      const schemeAndClass = investorInfo.schemes.map(
        (item, index) => `${item.scheme_name}-${item.scheme_class}`
      );
      setSchemeAndClassOption(schemeAndClass);
    } else {
      setSchemeAndClassOption([]);
    }
    if (investorInfo) {
      setInvestorDetailsForPDF(investorInfo);
    }
  }, [investorInfo]);

  // const handleGetInvestorInfo=async()=>{
  //   // dispatch(loaderSet(true))
  //   const payload={
  //     user_email: "sekarnadar456@gmail.com",
  //     user_type: "investor",
  //     user_id: "user_a3bbc922"
  //   }
  //   try {
  //     const response=await getInvestorInfo(payload)
  //     console.log("response for handleGetInvestorInfo",response)
  //     if(response){
  //       // setScheme(response?.schemes.map((item,index)=>(${item.scheme_name}-${item.scheme_class})))
  //       // if(scheme?.length>0){
  //       //   setSelectedSchemeOptions(scheme)
  //       //   console.log("setSelectedSchemeOptions(scheme)",scheme)

  //       // }

  //       // dispatch(loaderSet(false))
  //     }
  //   } catch (error) {
  //     console.log("Error in handleGetInvestorInfo function ",error)
  //     // dispatch(loaderSet(false))
  //   }
  // }

  const tabsList = [
    {
      label: "Overview",
      value: "overview",
      component: <Overview  selectedSchemeOptions={selectedSchemeOptions}  />,
    },
    {
      label: "Performance",
      value: "performance",
      component: <Performance selectedSchemeOptions={selectedSchemeOptions} />,
    },
    // {
    //   label: "Fund Manager",
    //   value: "fundManager",
    //   component: <FundManagers />,
    // },
    {
      label: "Portfolio",
      value: "portfolio",
      component: <Portfolio selectedSchemeOptions={selectedSchemeOptions} />,
    },
    {
      label: "Scheme Documents",
      value: "schemeDocuments",
      component: <SchemeDocuments selectedSchemeOptions={selectedSchemeOptions} />,
    },
  ];

  const handleGetSchemeDetailsAgainstInvestor = async () => {
    if (investorInfo && investorInfo?.schemes) {
      const payload = {
        schemes: investorInfo.schemes,
      };
      console.log(
        " handleGetSchemeDetailsAgainstInvestor",
        payload,
        investorInfo?.schemes
      );
      try {
        const response = await getSchemeInfoAgainstInvestor(payload);
        if (response) {
          // dispatch(setAllSchemeDetails(response.data));
          // setAumData(response?.aumData)
           dispatch(setSchemeInfoDetailsAgainstInvestor(response.data))
                dispatch(setAUMDataAgainstScheme(response.aumData))
        }
        console.log(
          "response for handleGetSchemeDetailsAgainstInvestor ",
          response
        );
      } catch (error) {
        console.log(
          "Error in handleGetSchemeDetailsAgainstInvestor function ",
          error
        );
      }
    }
  };

  useEffect(() => {
    handleGetSchemeDetailsAgainstInvestor();
  }, [investorInfo]);

  useEffect(() => {
    if (
      allSchemeDetails &&
      allSchemeDetails.length > 0 &&
      selectedSchemeOptions &&
      selectedSchemeOptions.length > 0
    ) {
      const tickerMessage =
        allSchemeDetails
          .filter(
            (scheme) =>
              scheme.scheme_class === selectedSchemeOptions[0]?.split("-")[1] &&
              scheme.scheme_name === selectedSchemeOptions[0]?.split("-")[0] &&
              scheme.ticker_status === true
          )
          .map((scheme) => scheme.ticker_message)
          .find((message) => message !== null) || false; // Returns the message or false if none found

      // Trigger handleSetTickerMessage only if tickerMessage is found
      console.log("TICKER MESSAGE:", tickerMessage);
      handleSetTickerMessage(tickerMessage);
    }
  }, [selectedSchemeOptions, allSchemeDetails]); // Depend on selectedSchemeOptions and allSchemeDetails

  useEffect(() => {
    if (schemeAndClassOption?.length > 0) {
      setSelectedSchemeOptions(schemeAndClassOption);
      console.log(
        "setSelectedSchemeOptions updated with",
        schemeAndClassOption
      );
    }
  }, [schemeAndClassOption]); // Depend on the scheme state

  // useEffect(()=>{
  //   handleGetInvestorInfo()
  //   console.log(" selectedSchemeOptions",selectedSchemeOptions,scheme)
  // },[])

  return (
    <div className="flex min-h-screen w-full flex-col  ">
      <div className="flex flex-col sm:gap-4  sm:pl-1">
        <main className="grid flex-1 items-start gap-4  ">
          <h1 className="sr-only">Investor Dashboard</h1>
          <div className="grid auto-rows-max items-start gap-4 md:gap-8  lg:col-span-2">
            <div className="flex items-center gap-6 justify-end">
              {/* Dropdown Section */}
              <div className="w-64 h-10">
                <AdvancedDropdown
                  name="Scheme"
                  id="scheme"
                  options={schemeAndClassOption}
                  selectedOptions={selectedSchemeOptions}
                  setSelectedOptions={setSelectedSchemeOptions}
                  placeholder="Scheme"
                  select={"single"}
                  label={false}
                />
              </div>

              {/* Download Button */}
              <DownloadButton
                selectedSchemeOptions={selectedSchemeOptions}
                investorDetails={investorDetailsForPDF}
                className="inline-flex h-10 items-center justify-center gap-1 rounded-md border border-[#3a5dd1] bg-transparent px-4 text-[#0D215C] text-md font-semibold"
                label={
                  <>
                    <span className="ml-1 text-[#0D215C]">
                      <DownloadIcon aria-hidden="true" focusable="false" />
                    </span>
                    <span>Download Report</span>
                  </>
                }
              />
            </div>

            <Tabs defaultValue="overview">
              <div className="flex bg-white items-center flex-col ">
                <div className=" flex  w-full flex-col items-start  mt-2">
                  <TabsList
                    className="  bg-white border-b-2 w-full rounded-none flex justify-start "
                    aria-label="Investor dashboard tabs"
                  >
                    {tabsList.map((curElem, index) => (
                      <TabsTrigger
                        key={index}
                        value={curElem.value}
                          tabIndex={index + 1}
                        className="text-[#1f2937] data-[state=active]:text-[#0D215C] data-[state=active]:font-bold data-[state=active]:border-b-2 data-[state=active]:border-[#0D215C]"
                      >
                        {curElem.label}
                      </TabsTrigger>
                    ))}
                  </TabsList>
                </div>
                <div className="w-full flex justify-between items-start p-2">
                  <div className="flex w-full justify-end items-center gap-4">
                    {/* Dropdown Menu */}
                  </div>
                </div>
              </div>
              {tabsList.map((curElem, index) => (
                <TabsContent key={index} value={curElem.value}>
                  <Card x-chunk="dashboard-05-chunk-3">
                    <CardContent>
                      <div className=" w-full  flex justify-center items-center text-center"></div>
                      {curElem.component}
                    </CardContent>
                  </Card>
                </TabsContent>
              ))}
            </Tabs>
          </div>
          <div></div>
        </main>
      </div>

     
    </div>
  );
}
